import { c as _c } from "react/compiler-runtime";
import { Box, Button, Center, Separator, Heading, HStack, Icon, LinkBox, SimpleGrid, Spinner, Text, VStack } from '@chakra-ui/react';
import { accountNavItems } from '@src/components/sco/Account/Layout/AccountNav';
import { CalloutStack } from '@src/components/sco/CalloutStack';
import { InvestorSearchesList } from '@src/components/sco/InvestorMatching/InvestorSearchesList';
import { UserSearchesList } from '@src/components/sco/Matching/UserSearchesList';
import { PitchDeckList } from '@src/components/sco/PitchDeckAuditor';
import { RequestsGrid } from '@src/components/sco/Requests/RequestsGrid';
import { SupportOptionsBlock } from '@src/components/sco/SupportOptionsBlock';
import { AddIcon } from '@src/components/sco/icons';
import { BreakpointContextProvider, useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoSubscription, ScoUser } from '@src/graphql-types';
import { useCurrentUser } from '@src/hooks/useCurrentUser';
import { sortBy } from 'lodash';
import moment from 'moment/moment';
import { useRouter } from 'next/navigation';
import React from 'react';
import { LuClock, LuCreditCard, LuMail } from 'react-icons/lu';
export const getAccountAlerts = (currentUser: ScoUser) => {
  const accountAlerts: Array<{
    key: string;
    title: string;
    href: string;
    ctaLabel: string;
    icon: any;
  }> = [];
  if (!currentUser.emailConfirmedAt) {
    accountAlerts.push({
      icon: LuMail,
      key: 'confirm-email',
      href: '/account/security?resendConfirmation=true',
      title: 'Your email has not yet been confirmed.',
      ctaLabel: 'Confirm Your Email'
    });
  }
  if (currentUser?.subscriptions) {
    let trialSubscriptions = currentUser.subscriptions.filter(s => s.state === 'in_trial');
    if (trialSubscriptions.length && trialSubscriptions.length == currentUser?.subscriptions.length) {
      trialSubscriptions = sortBy(trialSubscriptions, (s: ScoSubscription) => moment(s.currentPeriodEndsAt));
      const userTrialEndingAt = trialSubscriptions[0]?.currentPeriodEndsAt;
      accountAlerts.push({
        icon: LuClock,
        key: 'trial-ending',
        href: '/account/billing',
        title: `Your trial ends ${moment(userTrialEndingAt).fromNow()}!`,
        ctaLabel: 'Explore Upgrade Options'
      });
    }
    const dunningSubscriptions = currentUser.subscriptions.filter(s => s.isActive && s.balanceInCents > 0);
    if (dunningSubscriptions.length > 0) {
      accountAlerts.push({
        icon: LuCreditCard,
        key: 'dunning',
        href: '/account/billing',
        title: `We've had trouble renewing your subscription.`,
        ctaLabel: 'Update Payment Information'
      });
    }
  }
  return accountAlerts;
};
export const AccountLaunchpad = props => {
  const $ = _c(54);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  const {
    currentUser
  } = useCurrentUser();
  const router = useRouter();
  if (!currentUser) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <Center padding="1em"><Spinner /></Center>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let T0;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] !== currentUser || $[2] !== getBreakpointValue) {
    const accountAlerts = currentUser ? getAccountAlerts(currentUser) : [];
    T0 = VStack;
    t0 = "stretch";
    t1 = "1em";
    t2 = "full";
    const t8 = currentUser.firstName || currentUser.email;
    if ($[12] !== t8) {
      t3 = <Heading marginBottom="1em">{"Welcome back, "}{t8}!</Heading>;
      $[12] = t8;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <HStack><Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Quick Links</Text><Separator flexGrow={1} /></HStack>;
      $[14] = t4;
    } else {
      t4 = $[14];
    }
    let t9;
    if ($[15] !== getBreakpointValue) {
      t9 = getBreakpointValue([1, 2, 3, 5]);
      $[15] = getBreakpointValue;
      $[16] = t9;
    } else {
      t9 = $[16];
    }
    let t10;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = accountNavItems.filter(_temp).map(_temp2);
      $[17] = t10;
    } else {
      t10 = $[17];
    }
    if ($[18] !== t10 || $[19] !== t9) {
      t5 = <SimpleGrid columns={t9} gap={4}>{t10}</SimpleGrid>;
      $[18] = t10;
      $[19] = t9;
      $[20] = t5;
    } else {
      t5 = $[20];
    }
    if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <HStack marginTop="3em"><Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Account Alerts</Text><Separator flexGrow={1} /></HStack>;
      $[21] = t6;
    } else {
      t6 = $[21];
    }
    t7 = accountAlerts.length == 0 ? <Box bgColor="colorPalette.container" borderRadius="md" padding={6} width="full"><CalloutStack><Heading size="md">All clear! No alerts.</Heading></CalloutStack></Box> : <VStack width="full">{accountAlerts.map(_temp3)}</VStack>;
    $[1] = currentUser;
    $[2] = getBreakpointValue;
    $[3] = T0;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    T0 = $[3];
    t0 = $[4];
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
  }
  let t8;
  let t9;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Your Goals</Text>;
    t9 = <Separator flexGrow={1} />;
    $[22] = t8;
    $[23] = t9;
  } else {
    t8 = $[22];
    t9 = $[23];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <HStack marginTop="3em">{t8}{t9}<Box><Button asChild={true} size="xs"><NextLink href="/requests/start"><AddIcon />Create a Goal</NextLink></Button></Box></HStack>;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== currentUser.userId) {
    t11 = <>{t10}<RequestsGrid variables={{
        requestingUserId: currentUser.userId
      }} renderEmpty={_temp4} /></>;
    $[25] = currentUser.userId;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  let t13;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Your Fundraises</Text>;
    t13 = <Separator flexGrow={1} />;
    $[27] = t12;
    $[28] = t13;
  } else {
    t12 = $[27];
    t13 = $[28];
  }
  let t14;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <HStack marginTop="3em">{t12}{t13}<Box><Button asChild={true} size="xs"><NextLink href="/investors/matching/start"><AddIcon />Create a Fundraise</NextLink></Button></Box></HStack>;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  let t15;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <InvestorSearchesList excludeEmptyResults={true} hideTitle={true} resultsSimpleGridProps={{
      columns: [1, 1, 2, 3]
    }} renderEmpty={_temp5} />;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  let t17;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Your Pitch Decks</Text>;
    t17 = <Separator flexGrow={1} />;
    $[31] = t16;
    $[32] = t17;
  } else {
    t16 = $[31];
    t17 = $[32];
  }
  let t18;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <HStack marginTop="3em">{t16}{t17}<Box><Button asChild={true} size="xs"><NextLink href="/pitch-decks"><AddIcon />Audit a New Deck</NextLink></Button></Box></HStack>;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== router) {
    t19 = <>{t18}<PitchDeckList renderEmpty={_temp6} onOpen={pitchDeckId => router.push(`/pitch-decks/${pitchDeckId}`)} /></>;
    $[34] = router;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  let t21;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Your Member Matches</Text>;
    t21 = <Separator flexGrow={1} />;
    $[36] = t20;
    $[37] = t21;
  } else {
    t20 = $[36];
    t21 = $[37];
  }
  let t22;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <HStack marginTop="3em">{t20}{t21}<Box><Button asChild={true} size="xs"><NextLink href="/requests/start"><AddIcon />Create a New Search</NextLink></Button></Box></HStack>;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <UserSearchesList excludeEmptyResults={true} hideTitle={true} resultsSimpleGridProps={{
      columns: [1, 1, 2, 3]
    }} renderEmpty={_temp7} />;
    $[39] = t23;
  } else {
    t23 = $[39];
  }
  let t24;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <HStack marginTop="2em"><Text opacity={0.75} textStyle="labelXs" whiteSpace="nowrap">Need Help?</Text><Separator flexGrow={1} /></HStack>;
    $[40] = t24;
  } else {
    t24 = $[40];
  }
  let t25;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Box width="full"><BreakpointContextProvider><SupportOptionsBlock /></BreakpointContextProvider></Box>;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  let t26;
  if ($[42] !== T0 || $[43] !== t0 || $[44] !== t1 || $[45] !== t11 || $[46] !== t19 || $[47] !== t2 || $[48] !== t3 || $[49] !== t4 || $[50] !== t5 || $[51] !== t6 || $[52] !== t7) {
    t26 = <T0 align={t0} gap={t1} width={t2}>{t3}{t4}{t5}{t6}{t7}{t11}{t14}{t15}{t19}{t22}{t23}{t24}{t25}</T0>;
    $[42] = T0;
    $[43] = t0;
    $[44] = t1;
    $[45] = t11;
    $[46] = t19;
    $[47] = t2;
    $[48] = t3;
    $[49] = t4;
    $[50] = t5;
    $[51] = t6;
    $[52] = t7;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  return t26;
};
function _temp(item) {
  return ["Email & Login", "Personal Profile", "Skills & Experiences", "Startup Profile", "Billing"].includes(`${item.title}`);
}
function _temp2(item_0, idx) {
  return <LinkBox key={idx} asChild={true} bgColor="colorPalette.container" border="1px solid transparent" borderRadius="lg" boxShadow="sm" display="block" paddingX={2} paddingY={6} textAlign="center" transition="all 150ms" width="full" _hover={{
    bgColor: "colorPalette.container/50",
    borderColor: "colorPalette.border"
  }}><NextLink key={idx} href={item_0.href}><VStack gap={2}><Icon asChild={true}><item_0.icon /></Icon><Text fontSize="sm">{item_0.title}</Text></VStack></NextLink></LinkBox>;
}
function _temp3(alert, idx_0) {
  return <HStack key={idx_0} bgColor="colorPalette.card" borderRadius="lg" padding="1.5em" width="full"><Icon asChild={true}><alert.icon /></Icon><Text flexGrow={1}>{alert.title}</Text>{alert.ctaLabel && <Button asChild={true} variant="cta"><NextLink href={alert.href || "#"} prefetch={false}>{alert.ctaLabel || "Fix"}</NextLink></Button>}</HStack>;
}
function _temp4() {
  return <Box bgColor="colorPalette.container" borderRadius="md" padding={6} width="full"><CalloutStack><Heading size="md">No requests yet.</Heading><HStack><Button asChild={true} size="sm" variant="outline"><NextLink href="/requests">Learn More</NextLink></Button><Button asChild={true} size="sm" variant="cta"><NextLink href="/requests/start">Create a Goal</NextLink></Button></HStack></CalloutStack></Box>;
}
function _temp5() {
  return <Box bgColor="colorPalette.container" borderRadius="md" padding={6} width="full"><CalloutStack><Heading size="md">No fundraises yet.</Heading><HStack><Button asChild={true} size="sm" variant="outline"><NextLink href="/investors/matching">Learn More</NextLink></Button><Button asChild={true} size="sm" variant="cta"><NextLink href="/investors/matching/start">Start a Fundraise</NextLink></Button></HStack></CalloutStack></Box>;
}
function _temp6() {
  return <Box bgColor="colorPalette.container" borderRadius="md" padding={6} width="full"><CalloutStack><Heading size="md">No pitch decks yet.</Heading><HStack><Button asChild={true} size="sm" variant="outline"><NextLink href="/pitch-deck-auditor">Learn More</NextLink></Button><Button asChild={true} size="sm" variant="cta"><NextLink href="/pitch-decks">Audit a Deck</NextLink></Button></HStack></CalloutStack></Box>;
}
function _temp7() {
  return <Box bgColor="colorPalette.container" borderRadius="md" padding={6} width="full"><CalloutStack><Heading size="md">No member searches yet.</Heading><HStack><Button asChild={true} size="sm" variant="outline"><NextLink href="/members/matching">Learn More</NextLink></Button><Button asChild={true} size="sm" variant="cta"><NextLink href="/members/matching/start">Start a Search</NextLink></Button></HStack></CalloutStack></Box>;
}